
import React from "react";
import { MapPin, Users, Building, Truck } from "lucide-react";

interface ServiceAreaSectionProps {
  siteName: string;
  city: string;
}

const ServiceAreaSection: React.FC<ServiceAreaSectionProps> = ({ siteName, city }) => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-fabre-green mb-6 text-center">
            Zone d'intervention du Groupe Fabre Environnement
          </h2>
          
          <div className="prose max-w-none text-gray-700 mb-8">
            <p className="text-center mb-6">
              {siteName} fait partie du réseau Groupe Fabre Environnement, 
              leader régional de la gestion et valorisation des déchets. 
              Notre implantation stratégique à {city} nous permet de servir efficacement 
              l'ensemble de la région et les départements limitrophes.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="text-center">
              <div className="bg-fabre-lightgreen rounded-full p-4 w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                <MapPin className="h-8 w-8 text-fabre-darkgreen" />
              </div>
              <h3 className="font-semibold text-fabre-darkgreen mb-2">Multi-régional</h3>
              <p className="text-sm text-gray-600">
                Présence dans plusieurs régions françaises
              </p>
            </div>

            <div className="text-center">
              <div className="bg-fabre-lightgreen rounded-full p-4 w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                <Building className="h-8 w-8 text-fabre-darkgreen" />
              </div>
              <h3 className="font-semibold text-fabre-darkgreen mb-2">15+ Sites</h3>
              <p className="text-sm text-gray-600">
                Centres de recyclage et valorisation
              </p>
            </div>

            <div className="text-center">
              <div className="bg-fabre-lightgreen rounded-full p-4 w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                <Users className="h-8 w-8 text-fabre-darkgreen" />
              </div>
              <h3 className="font-semibold text-fabre-darkgreen mb-2">Proximité</h3>
              <p className="text-sm text-gray-600">
                Service de proximité personnalisé
              </p>
            </div>

            <div className="text-center">
              <div className="bg-fabre-lightgreen rounded-full p-4 w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                <Truck className="h-8 w-8 text-fabre-darkgreen" />
              </div>
              <h3 className="font-semibold text-fabre-darkgreen mb-2">Logistique</h3>
              <p className="text-sm text-gray-600">
                Collecte et transport optimisés
              </p>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-fabre-darkgreen mb-4">
              Départements d'intervention principaux
            </h3>
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <h4 className="font-medium text-gray-800 mb-2">Auvergne-Rhône-Alpes</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Cantal (15)</li>
                  <li>• Puy-de-Dôme (63)</li>
                  <li>• Haute-Loire (43)</li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-gray-800 mb-2">Occitanie</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Aveyron (12)</li>
                  <li>• Tarn (81)</li>
                  <li>• Lot (46)</li>
                  <li>• Lozère (48)</li>
                  <li>• Haute-Garonne (31)</li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-gray-800 mb-2">Autres régions</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Val-d'Oise (95)</li>
                  <li>• Gironde (33)</li>
                  <li>• Et départements limitrophes</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">
              Grâce à notre réseau étendu et notre expertise locale, nous garantissons 
              un service de qualité adapté aux spécificités de chaque territoire.
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              <span className="bg-fabre-lightgreen px-3 py-1 rounded-full text-sm text-fabre-darkgreen">
                Collecte professionnelle
              </span>
              <span className="bg-fabre-lightgreen px-3 py-1 rounded-full text-sm text-fabre-darkgreen">
                Valorisation énergétique
              </span>
              <span className="bg-fabre-lightgreen px-3 py-1 rounded-full text-sm text-fabre-darkgreen">
                Recyclage métaux
              </span>
              <span className="bg-fabre-lightgreen px-3 py-1 rounded-full text-sm text-fabre-darkgreen">
                Location de bennes
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
